import React, { useState } from 'react';

const FormsBlock = ({ data, isSelected, onSelect, onUpdate, isPreview }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState(data);

  const handleSave = () => {
    onUpdate(editData);
    setIsEditing(false);
  };

  const handleCancel = () => {
    setEditData(data);
    setIsEditing(false);
  };

  const handleInputChange = (field, value) => {
    setEditData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const addField = () => {
    setEditData(prev => ({
      ...prev,
      fields: [...prev.fields, 'text']
    }));
  };

  const removeField = (index) => {
    setEditData(prev => ({
      ...prev,
      fields: prev.fields.filter((_, i) => i !== index)
    }));
  };

  const updateField = (index, value) => {
    setEditData(prev => ({
      ...prev,
      fields: prev.fields.map((field, i) => i === index ? value : field)
    }));
  };

  const fieldTypes = [
    { value: 'text', label: 'Text Input' },
    { value: 'email', label: 'Email' },
    { value: 'tel', label: 'Phone' },
    { value: 'textarea', label: 'Text Area' },
    { value: 'select', label: 'Dropdown' },
    { value: 'checkbox', label: 'Checkbox' },
    { value: 'radio', label: 'Radio Button' }
  ];

  if (isPreview) {
    return (
      <section style={{
        padding: '4rem 0',
        backgroundColor: '#f8f9fa'
      }}>
        <div style={{
          maxWidth: '800px',
          margin: '0 auto',
          padding: '0 2rem'
        }}>
          <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
            <h2 style={{
              fontSize: '2.5rem',
              fontWeight: 'bold',
              marginBottom: '1rem',
              color: '#333'
            }}>
              {data.title || 'Get in Touch'}
            </h2>
            <p style={{
              fontSize: '1.125rem',
              color: '#666',
              lineHeight: '1.6'
            }}>
              {data.description || 'Send us a message and we\'ll get back to you'}
            </p>
          </div>

          <form style={{
            backgroundColor: 'white',
            padding: '2rem',
            borderRadius: '0.5rem',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
          }}>
            {data.fields?.map((field, index) => (
              <div key={index} style={{ marginBottom: '1.5rem' }}>
                <label style={{
                  display: 'block',
                  marginBottom: '0.5rem',
                  fontWeight: '500',
                  color: '#333'
                }}>
                  {field.charAt(0).toUpperCase() + field.slice(1)} *
                </label>
                {field === 'textarea' ? (
                  <textarea
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      border: '1px solid #d1d5db',
                      borderRadius: '0.25rem',
                      fontSize: '1rem',
                      resize: 'vertical',
                      minHeight: '120px'
                    }}
                    placeholder={`Enter your ${field}...`}
                  />
                ) : (
                  <input
                    type={field}
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      border: '1px solid #d1d5db',
                      borderRadius: '0.25rem',
                      fontSize: '1rem'
                    }}
                    placeholder={`Enter your ${field}...`}
                  />
                )}
              </div>
            ))}

            <button
              type="submit"
              style={{
                width: '100%',
                backgroundColor: '#007bff',
                color: 'white',
                padding: '0.75rem 1.5rem',
                border: 'none',
                borderRadius: '0.25rem',
                fontSize: '1rem',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'background-color 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#0056b3';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#007bff';
              }}
            >
              {data.submitText || 'Send Message'}
            </button>
          </form>
        </div>
      </section>
    );
  }

  return (
    <div
      style={{
        border: isSelected ? '2px solid #007bff' : '2px solid #dee2e6',
        borderRadius: '0.5rem',
        backgroundColor: 'white',
        marginBottom: '1rem',
        position: 'relative'
      }}
      onClick={onSelect}
    >
      {/* Block Header */}
      <div style={{
        padding: '0.75rem 1rem',
        backgroundColor: '#f8f9fa',
        borderBottom: '1px solid #dee2e6',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <span style={{ fontSize: '1.25rem' }}>📝</span>
          <span style={{ fontWeight: '600' }}>Forms Block</span>
        </div>
        <button
          onClick={(e) => {
            e.stopPropagation();
            setIsEditing(!isEditing);
          }}
          style={{
            padding: '0.25rem 0.5rem',
            backgroundColor: isEditing ? '#dc3545' : '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '0.25rem',
            cursor: 'pointer',
            fontSize: '0.75rem'
          }}
        >
          {isEditing ? 'Cancel' : 'Edit'}
        </button>
      </div>

      {/* Block Content */}
      <div style={{ padding: '1rem' }}>
        {isEditing ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            {/* Title */}
            <div>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                Form Title
              </label>
              <input
                type="text"
                value={editData.title || ''}
                onChange={(e) => handleInputChange('title', e.target.value)}
                style={{
                  width: '100%',
                  padding: '0.5rem',
                  border: '1px solid #dee2e6',
                  borderRadius: '0.25rem',
                  fontSize: '1rem'
                }}
              />
            </div>

            {/* Description */}
            <div>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                Description
              </label>
              <textarea
                value={editData.description || ''}
                onChange={(e) => handleInputChange('description', e.target.value)}
                rows="3"
                style={{
                  width: '100%',
                  padding: '0.5rem',
                  border: '1px solid #dee2e6',
                  borderRadius: '0.25rem',
                  fontSize: '1rem',
                  resize: 'vertical'
                }}
              />
            </div>

            {/* Form Type */}
            <div>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                Form Type
              </label>
              <select
                value={editData.formType || 'contact'}
                onChange={(e) => handleInputChange('formType', e.target.value)}
                style={{
                  width: '100%',
                  padding: '0.5rem',
                  border: '1px solid #dee2e6',
                  borderRadius: '0.25rem',
                  fontSize: '1rem'
                }}
              >
                <option value="contact">Contact Form</option>
                <option value="newsletter">Newsletter Signup</option>
                <option value="quote">Quote Request</option>
                <option value="custom">Custom Form</option>
              </select>
            </div>

            {/* Form Fields */}
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
                <label style={{ fontWeight: '500' }}>Form Fields</label>
                <button
                  onClick={addField}
                  style={{
                    padding: '0.25rem 0.5rem',
                    backgroundColor: '#28a745',
                    color: 'white',
                    border: 'none',
                    borderRadius: '0.25rem',
                    cursor: 'pointer',
                    fontSize: '0.75rem'
                  }}
                >
                  + Add Field
                </button>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                {editData.fields?.map((field, index) => (
                  <div key={index} style={{
                    display: 'flex',
                    gap: '0.5rem',
                    alignItems: 'center'
                  }}>
                    <select
                      value={field}
                      onChange={(e) => updateField(index, e.target.value)}
                      style={{
                        flex: 1,
                        padding: '0.5rem',
                        border: '1px solid #dee2e6',
                        borderRadius: '0.25rem',
                        fontSize: '0.875rem'
                      }}
                    >
                      {fieldTypes.map(type => (
                        <option key={type.value} value={type.value}>
                          {type.label}
                        </option>
                      ))}
                    </select>
                    <button
                      onClick={() => removeField(index)}
                      style={{
                        padding: '0.25rem 0.5rem',
                        backgroundColor: '#dc3545',
                        color: 'white',
                        border: 'none',
                        borderRadius: '0.25rem',
                        cursor: 'pointer',
                        fontSize: '0.75rem'
                      }}
                    >
                      Remove
                    </button>
                  </div>
                )) || []}
              </div>
            </div>

            {/* Submit Button Text */}
            <div>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                Submit Button Text
              </label>
              <input
                type="text"
                value={editData.submitText || ''}
                onChange={(e) => handleInputChange('submitText', e.target.value)}
                style={{
                  width: '100%',
                  padding: '0.5rem',
                  border: '1px solid #dee2e6',
                  borderRadius: '0.25rem',
                  fontSize: '1rem'
                }}
              />
            </div>

            {/* Success Message */}
            <div>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                Success Message
              </label>
              <input
                type="text"
                value={editData.successMessage || ''}
                onChange={(e) => handleInputChange('successMessage', e.target.value)}
                style={{
                  width: '100%',
                  padding: '0.5rem',
                  border: '1px solid #dee2e6',
                  borderRadius: '0.25rem',
                  fontSize: '1rem'
                }}
              />
            </div>

            {/* Action Buttons */}
            <div style={{ display: 'flex', gap: '0.5rem', marginTop: '1rem' }}>
              <button
                onClick={handleSave}
                style={{
                  flex: 1,
                  padding: '0.5rem',
                  backgroundColor: '#28a745',
                  color: 'white',
                  border: 'none',
                  borderRadius: '0.25rem',
                  cursor: 'pointer'
                }}
              >
                Save
              </button>
              <button
                onClick={handleCancel}
                style={{
                  flex: 1,
                  padding: '0.5rem',
                  backgroundColor: '#6c757d',
                  color: 'white',
                  border: 'none',
                  borderRadius: '0.25rem',
                  cursor: 'pointer'
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        ) : (
          <div style={{
            padding: '1.5rem',
            backgroundColor: '#f8f9fa',
            borderRadius: '0.25rem',
            textAlign: 'center'
          }}>
            <h3 style={{ margin: '0 0 0.5rem 0', fontSize: '1.25rem', fontWeight: '600' }}>
              {data.title || 'Forms Block'}
            </h3>
            <p style={{ margin: 0, color: '#666', fontSize: '0.875rem' }}>
              {data.fields?.length || 0} field(s) configured
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default FormsBlock;
